import { useNavigate, useLocation } from "@/lib/router-compat";
import { ChevronLeft, Home, Truck, Wrench, Phone } from "lucide-react";
import { cn } from "@/lib/utils";

const tabs = [
  { icon: Home, label: "Home", path: "/" },
  { icon: Truck, label: "Shop", path: "/rv-search" },
  { icon: Wrench, label: "Service", path: "/rv-service" },
  { icon: Phone, label: "Contact", path: "/contact-us" },
];

const MobileBottomNav = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  // Hide on admin routes
  if (pathname.startsWith("/admin")) return null;

  return (
    <nav
      className="fixed bottom-0 inset-x-0 z-50 lg:hidden border-t border-border/40 bg-background/90 backdrop-blur-xl"
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
    >
      <div className="flex items-center justify-around h-14">
        {/* Back button */}
        <button
          onClick={() => navigate(-1)}
          className="flex flex-col items-center justify-center gap-0.5 flex-1 h-full text-muted-foreground active:text-primary transition-colors"
          aria-label="Go back"
        >
          <ChevronLeft className="h-5 w-5" />
          <span className="text-[10px] font-medium">Back</span>
        </button>

        {/* Nav tabs */}
        {tabs.map(({ icon: Icon, label, path }) => {
          const isActive = pathname === path || (path !== "/" && pathname.startsWith(path));
          return (
            <button
              key={path}
              onClick={() => navigate(path)}
              className={cn(
                "flex flex-col items-center justify-center gap-0.5 flex-1 h-full transition-colors",
                isActive ? "text-primary" : "text-muted-foreground active:text-primary"
              )}
              aria-label={label}
            >
              <Icon className="h-5 w-5" />
              <span className="text-[10px] font-medium">{label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileBottomNav;
